export const mascaraCpf = (v: string | undefined) => {
  if(!v || typeof v !== 'string') return ""
  v = v.replace(/\D/g, '')

  if (v.length <= 14) {
    v = v.replace(/(\d{3})(\d)/, '$1.$2')
    v = v.replace(/(\d{3})(\d)/, '$1.$2')
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
  }

  return v
}
